import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from "react";
import ProductListingFilter from "@/components/filter-panel/ProductListing";
interface MobileFilterProps {
  onClose: () => void;
  isCollection?: boolean;
  isThemeCake?: boolean;
  initialNavigationData?: any;
  searchParams?: {
    [key: string]: string | string[] | undefined;
  };
  selectedProductType?: any;
}
const MobileFilter: React.FC<MobileFilterProps> = t0 => {
  const $ = _c(13);
  const {
    onClose,
    isCollection,
    isThemeCake,
    initialNavigationData,
    searchParams,
    selectedProductType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp2, t1);
  let t2;
  if ($[1] !== onClose) {
    t2 = <button onClick={onClose} className="absolute top-2 right-4 text-stone-400 z-50 p-2 hover:bg-stone-50 rounded-full transition-colors">✕</button>;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== initialNavigationData || $[4] !== isCollection || $[5] !== isThemeCake || $[6] !== onClose || $[7] !== searchParams || $[8] !== selectedProductType) {
    t3 = <div className="w-full flex-1 pt-6 pb-6 overflow-y-auto no-scrollbar scrollbar-hide"><ProductListingFilter isCollection={isCollection} isThemeCake={isThemeCake} initialNavigationData={initialNavigationData} onClose={onClose} searchParams={searchParams} selectedProductType={selectedProductType} /></div>;
    $[3] = initialNavigationData;
    $[4] = isCollection;
    $[5] = isThemeCake;
    $[6] = onClose;
    $[7] = searchParams;
    $[8] = selectedProductType;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <div className="w-full flex-1 flex flex-col items-start justify-center bg-white relative overflow-hidden">{t2}{t3}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default MobileFilter;
function _temp() {
  document.body.classList.remove("overflow-hidden");
}
function _temp2() {
  document.body.classList.add("overflow-hidden");
  return _temp;
}